document.querySelectorAll<HTMLElement>('.testimonial-slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.testimonial-slider__wrapper');
	const parent = slider.closest('.block-testimonial-slider');
	const slides = slider.querySelectorAll<HTMLElement>('.testimonial-slide');
	const images = parent?.querySelectorAll<HTMLElement>(
		'.block-testimonial-slider__background-image'
	);

	if (null !== wrapper && slides.length > 0) {
		let tallestHeight = 0;
		slides.forEach((slide) => {
			const slideHeight = slide.offsetHeight;
			if (slideHeight > tallestHeight) {
				tallestHeight = slideHeight;
			}
		});

		wrapper.style.height = tallestHeight + 'px';

		new (window as Window).Swiper(wrapper, {
			slidesPerView: 1,
			loop: true,
			spaceBetween: 20,
			direction: 'horizontal',
			navigation: {
				nextEl: slider.querySelector('.testimonial-pagination__button--next'),
				prevEl: slider.querySelector('.testimonial-pagination__button--prev'),
			},

			on: {
				slideChange(this: typeof window.Swiper) {
					const currentSlide = this.slides[this.activeIndex];

					if (images) {
						images.forEach((image) => {
							image.classList.remove('active');
						});
					}

					if (currentSlide) {
						const imageId = currentSlide.getAttribute('data-image-id');
						const matchingImage = parent?.querySelector<HTMLElement>(
							`.block-testimonial-slider__background-image[data-image-id="${imageId}"]`
						);
						if (matchingImage) {
							matchingImage.classList.add('active');
						}
					}
				},
			},
			breakpoints: {
				[window.impBreakpoints?.lg ?? 992]: {
					direction: 'vertical',
					spaceBetween: 48,
				},
			},
		});
	}
});
